// Central configuration for all remote backend / CDN hosts.
//
// This app is built on the K LIVE ARCHIVE (vlivearchive.com) open-source
// backend. Every external host is collected here so the whole stack can be
// pointed at a self-hosted backend by editing this one file (or by setting the
// matching REACT_APP_* environment variable at build time).

export const API_BASE =
  process.env.REACT_APP_API_BASE || "https://api.vlivearchive.com";

export const THUMBS_BASE =
  process.env.REACT_APP_THUMBS_BASE || "https://thumbs.vlivearchive.com";

export const THUMBS_SM_BASE =
  process.env.REACT_APP_THUMBS_SM_BASE || "https://thumbs-sm.vlivearchive.com";

export const SUBTITLE_BASE =
  process.env.REACT_APP_SUBTITLE_BASE || "https://subtitle.vlivearchive.com";

// Per-channel video files are served from "<bucket>.<VIDEO_HOST>".
export const VIDEO_HOST =
  process.env.REACT_APP_VIDEO_HOST || "vlivearchive.com";

// Convenience helpers ---------------------------------------------------------

// Channel profile picture (avatar) URL.
export const pfpUrl = (channelCode) => `${API_BASE}/pfp/${channelCode}.png`;
